<template>
  <header class="header-main">
    <div class="header-upper">
      <div class="container">
        <div class="row">
          <ul>
            <li><a href="#">Login</a></li>
            <!--
            <li>
              <a href="shopcart.html"
                ><i class="fa fa-shopping-cart"></i>
                <span>cart(<span class="cartitems">0</span>)</span></a
              >
            </li>-->
          </ul>
        </div>
      </div>
    </div>
    <div class="header-lower clearfix">
      <div class="container">
        <div class="row">
          <h1 class="logo">
            <router-link to="/"
              ><img src="@/assets/images/logo/logo-youtube.png" width="180" alt="logo"
            /></router-link>
          </h1>

          <div class="menubar">
            <nav class="navbar">
              <div class="nav-wrapper">
                <div class="navbar-header">
                  <button type="button" class="navbar-toggle">
                    <span class="sr-only">Toggle navigation</span>
                    <span class="icon-bar"></span>
                  </button>
                </div>
                <div class="nav-menu">
                  <ul class="nav navbar-nav menu-bar">
                    <li>
                      <router-link to="/" class="active">Home</router-link>
                    </li>
                    <li>
                      <router-link to="/about">About</router-link>
                    </li>
                    <li>
                      <a
                        >gallery <span></span> <span></span> <span></span>
                        <span></span
                      ></a>
                      <ul class="sub-menu">
                        <li><router-link to="/about">masonry</router-link></li>
                        <li>
                          <router-link to="/about"
                            >gallery column two</router-link
                          >
                        </li>
                        <li>
                          <router-link to="/about"
                            >gallery column 03</router-link
                          >
                        </li>
                      </ul>
                    </li>
                    <li>
                      <router-link to="/about">Blog</router-link>
                    </li>
                    <!--
                    <li>
                      <router-link to="/blog">Book Tickets </router-link>
                    </li>-->
                    <li>
                      <router-link to="/about">Shop</router-link>
                    </li>
                    <li>
                      <router-link to="/contact">Contact</router-link>
                    </li>
                    <!--
                    <li>
                      <a
                        >error <span></span> <span></span> <span></span>
                        <span></span
                      ></a>
                      <ul class="sub-menu">
                        <li><a href="400.html">400 page</a></li>
                        <li><a href="401.html">401 page</a></li>
                        <li><a href="403.html">403 page</a></li>
                        <li><a href="404.html">404 page</a></li>
                        <li><a href="500.html">500 page</a></li>
                        <li><a href="503.html">503 page</a></li>
                      </ul>
                    </li>-->
                  </ul>
                </div>
              </div>
            </nav>
          </div>
          <div class="social">
            <a
              href="https://www.facebook.com/templatespoint.net"
              class="facebook"
              ><i class="fa fa-facebook"></i
            ></a>
            <a href="https://twitter.com/itobuztech" class="twitter"
              ><i class="fa fa-twitter"></i
            ></a>
            <a href="https://www.behance.net/" class="behance"
              ><i class="fa fa-behance"></i
            ></a>
          </div>
        </div>
      </div>
    </div>
  </header>
</template>

<script></script>
